import { createContext, useMemo, useContext, useState, useEffect } from 'react';
import { useGeneral } from '../../Context/GeneralContext';

const ParosContext = createContext();

export function ParosProvider(props) {
    const { setIsInParosView } = useGeneral();
    const dias = useMemo(() => (['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado']), []);
    const [seleccionFila, setSeleccionFila] = useState([]);
    const [minX, setMinX] = useState(0);
    const [maxX, setMaxX] = useState(0);
    const meses = useMemo(() => ([
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
    ]), []);

    useEffect(() => {
        setIsInParosView(true);

        return () => {
            setIsInParosView(false);
        };
    }, [setIsInParosView]);

    const parosValues = useMemo(() => {
        return {
            dias,
            meses,
            seleccionFila,
            setSeleccionFila,
            maxX,
            setMaxX,
            minX,
            setMinX,
        };
    }, [dias, meses, seleccionFila, setSeleccionFila, maxX, setMaxX, minX, setMinX]);

    return <ParosContext.Provider value={parosValues} {...props} />;
}

export function useParos() {
    const context = useContext(ParosContext);
    if (!context) {
        throw new Error('useHome debe estar dentro del proveedor ParosContext');
    }
    return context;
}
